import * as THREE from 'three';

export interface LightingPreset {
  sunDir: THREE.Vector3;
  sun: number;
  sunIntensity: number;
  skyTop: number;
  skyHorizon: number;
  ground: number;
  hemi: number;
  fog: number;
}

export const LIGHTING: Record<'dawn' | 'day' | 'dusk', LightingPreset> = {
  dawn: { sunDir: new THREE.Vector3(-0.8, 0.45, 0.35), sun: 0xffc89a, sunIntensity: 2.2, skyTop: 0x5a7ab0, skyHorizon: 0xf0c8a0, ground: 0x5a4a3a, hemi: 0.9, fog: 0xd8c0a8 },
  day: { sunDir: new THREE.Vector3(-0.45, 0.8, 0.4), sun: 0xfff4e0, sunIntensity: 2.6, skyTop: 0x4a80c8, skyHorizon: 0xc8dcec, ground: 0x6a5a40, hemi: 1.1, fog: 0xbcd0e0 },
  dusk: { sunDir: new THREE.Vector3(0.75, 0.38, -0.4), sun: 0xffa070, sunIntensity: 2.0, skyTop: 0x2a3a70, skyHorizon: 0xe8906a, ground: 0x4a3a30, hemi: 0.8, fog: 0xb0907a },
};

/** Gradient sky dome with sun glow. */
export function buildSky(p: LightingPreset): THREE.Mesh {
  const geo = new THREE.SphereGeometry(900, 24, 12);
  const mat = new THREE.ShaderMaterial({
    side: THREE.BackSide,
    depthWrite: false,
    fog: false,
    uniforms: {
      uTop: { value: new THREE.Color(p.skyTop) },
      uHorizon: { value: new THREE.Color(p.skyHorizon) },
      uSun: { value: p.sunDir.clone().normalize() },
      uSunColor: { value: new THREE.Color(p.sun) },
    },
    vertexShader: `varying vec3 vDir; void main(){ vDir = normalize(position); gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }`,
    fragmentShader: `
      uniform vec3 uTop, uHorizon, uSun, uSunColor; varying vec3 vDir;
      void main(){
        float h = clamp(vDir.y, -0.2, 1.0);
        vec3 c = mix(uHorizon, uTop, pow(max(h, 0.0), 0.6));
        float s = max(dot(normalize(vDir), uSun), 0.0);
        c += uSunColor * (pow(s, 400.0) * 2.0 + pow(s, 12.0) * 0.25);
        gl_FragColor = vec4(c, 1.0);
        #include <colorspace_fragment>
      }`,
  });
  const m = new THREE.Mesh(geo, mat);
  m.renderOrder = -10;
  m.frustumCulled = false;
  return m;
}
